import { render } from "./DashboardAccountComponent.vue?vue&type=template&id=551982d1&scoped=true"
import script from "./DashboardAccountComponent.vue?vue&type=script&lang=js"
export * from "./DashboardAccountComponent.vue?vue&type=script&lang=js"

import "./DashboardAccountComponent.vue?vue&type=style&index=0&id=551982d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551982d1"]])

export default __exports__